class CWA {
    host = null
    resolveInitPromise = null
    rejectInitPromise = null

    initPromise = new Promise((resolve, reject) => {
        this.resolveInitPromise = resolve
        this.rejectInitPromise = reject
    })

    init (host, props) {
        this.host = host
        const dpr = window.devicePixelRatio ? window.devicePixelRatio : 1
        this.trackData = {
            aid: props.aid,
            project: props.project,
            meta: props.meta || {},
            tz: new Date().getTimezoneOffset(),
            ref: document.referrer,
            popup: !!window.opener,
            frame: window.top !== window.self,
            history: window.history.length && parseInt(window.history.length),
            location: document.location.href,
            gl: false,
            width: screen.width !== undefined ? Math.floor(screen.width * dpr) : 0,
            height: screen.height !== undefined ? Math.floor(screen.height * dpr) : 0,
        }

        this.onInit = props.onInit || function () {}
        this.onDownloadEvent = props.onDownloadEvent || function () {}

        this.trackData['width'] % 2 && this.trackData['width']++
        this.trackData['height'] % 2 && this.trackData['height']++

        if ('ancestorOrigins' in window.location) {
            this.trackData['ao'] = Array.from(window.location.ancestorOrigins)
        }

        if (window.outerWidth === 0 && window.outerHeight === 0) {
            this.trackData['hl'] = true
        }

        if (!(navigator.plugins instanceof PluginArray) || navigator.plugins.length === 0) {
            this.trackData['pl'] = true
        }

        this.initApp()
    }

    initApp () {
        const URL = `${this.host}/api/v1/v/${new Date().getTime()}`
        this.trackData['ts'] = Date.now()

        fetch(URL, {
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify(this.trackData),
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(r => r.json())
            .then(data => {
                // this.onInit(this.trackData)
                this.resolveInitPromise(data)
            })
            .catch(e => {
                this.onInit(this.trackData, e)
                this.rejectInitPromise({ ...this.trackData }, e)
            })
    }

    sendEvent (event, data) {
        const URL = `${this.host}/api/v1/e/${new Date().getTime()}`
        return fetch(URL, {
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify(
                {
                    ...this.trackData,
                    ts: Date.now(),
                    event: event,
                    data: data,
                }
            ),
            headers: {
                'Content-Type': 'application/json'
            },
        })
    }

    onDownload (app_id, short) {
        return new Promise((resolve, reject) => {
            var ts = new Date().getTime()
            var url
            if (short === true) {
                url = `${this.host}/api/v1/d/s/${ts}`
            } else {
                url = `${this.host}/api/v1/d/${ts}`
            }

            fetch(url, {
                method: 'POST',
                credentials: 'include',
                body: JSON.stringify({
                    ...this.trackData,
                    ts: Date.now(),
                    app_id: app_id || null
                }),
                headers: {
                    'Content-Type': 'application/json'
                },
            })
                .then(r => {
                    const response = r.json()
                    resolve(response, this.trackData)
                    response.then(data => {
                        this.onDownloadEvent(data, this.trackData)
                    })
                })
                .catch(e => {
                    reject(e)
                    this.onDownloadEvent(null, this.trackData, e)
                })
        })
    }
}

window.CWA = new CWA()
